"use client"
import {
  FormLabel,
  Stack,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material"
import { forwardRef, useId } from "react"

export type FormInputBaseProps = TextFieldProps & {
  isReadOnly?: boolean
  prefix?: string | React.ReactNode
  suffix?: string | React.ReactNode
}

// export interface TextFieldProps extends BaseTextFieldProps {}
export const FormInputBase = forwardRef<HTMLDivElement, FormInputBaseProps>(
  (props: FormInputBaseProps, ref) => {
    const {
      id,
      label,
      variant,
      name,
      children,
      isReadOnly = false,
      value = "",
      prefix,
      suffix,
      ...rest
    } = props
    const autoId = useId()
    const _id = id || autoId
    return (
      <Stack spacing={1} sx={{ width: "100%" }} id={`view-mode-${_id}`}>
        {label && (
          <FormLabel htmlFor={_id}>
            <Typography variant="h6">{label}</Typography>
          </FormLabel>
        )}
        {isReadOnly && (
          <Stack direction={"row"} spacing={1}>
            {prefix && (
              <Typography color="GrayText" component={"span"}>
                {prefix}
              </Typography>
            )}
            <Typography>{value as string}</Typography>
            {suffix && (
              <Typography color="GrayText" component={"span"}>
                {suffix}
              </Typography>
            )}
          </Stack>
        )}
        {!isReadOnly && (
          <TextField
            ref={ref}
            id={_id}
            name={name}
            value={value}
            variant={variant}
            {...rest}
          >
            {children}
          </TextField>
        )}
      </Stack>
    )
  },
)
FormInputBase.displayName = "FormInputBase"
